import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

export const JoinCircleDialog = ({ open, onOpenChange, code, setCode, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="surface-card max-w-sm">
      <DialogHeader>
        <DialogTitle>Join a Circle</DialogTitle>
        <DialogDescription>Enter the invite code you received.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <Input
          placeholder="e.g., ABC12345"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          className="rounded-xl font-mono text-center text-lg tracking-wider"
          data-testid="join-code-input"
          autoFocus
        />
        <Button
          onClick={onSubmit}
          className="w-full bg-gradient-to-r from-cyan-600 to-emerald-600 hover:from-cyan-700 hover:to-emerald-700 text-white"
          data-testid="submit-join-circle"
        >
          Join Circle
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
